import Swiper from "swiper";

class EpisodeSlider {
    swiper = {};
    tabContent: Array<any>;

    loaded: boolean
    recommendContainer: HTMLElement

    constructor() {

        let tabs = Array.from(document.querySelectorAll('.playlist__episodes-tab-item'));
        this.tabContent = Array.from(document.querySelectorAll('.playlist__tab-content'));
        this.recommendContainer = document.querySelector('#tab-recommend .swiper-wrapper') as HTMLElement;

        if (!tabs)
            return;

        this.loaded = false;

        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                let target = e.target as HTMLElement;
                let tabId = target.dataset.target
                tabs.forEach(item => {
                    item.classList.remove('active')
                });
                this.tabContent.forEach(item => {
                    item.classList.remove('active')
                })
                document.getElementById(tabId).classList.add('active')

                if (Object.keys(this.swiper).length === 0 && typeof this.swiper[tabId] !== 'undefined') {
                    if (this.swiper[tabId].destroyed) {
                        this.swiper[tabId].init()
                    }
                }


                target.classList.add('active')
            });
        });

        window.addEventListener('resize', this.checkSize.bind(this));
        this.checkSize()
    }

    checkScroll() {

        if (!this.recommendContainer)
            return;


       // let scrollTop = this.recommendContainer.scrollTop;

        let loadPosition = this.recommendContainer.offsetHeight - 50;

        this.recommendContainer.addEventListener('scroll', () => {

            if (this.recommendContainer.scrollTop > loadPosition && !this.loaded) {
                this.lazyLoad((msg) => {
                    $(this.recommendContainer).append(msg)
                })
            }
        });
    }

    lazyLoad(callback) {
        this.loaded = true;
        $.ajax({
            url: "/local/templates/kinochannel/components/bitrix/news.detail/episode/recommends.php",
            type: 'POST',
            // @ts-ignore
            data: lazyRecommendsParams,
            success: (result) => {
                result = JSON.parse(result)
                // @ts-ignore
                lazyRecommendsParams.EXCLUDE_ID = lazyRecommendsParams.EXCLUDE_ID.concat(result.excludeIds)
                callback(result.html)
                this.loaded = false;
            }
        });
    }

    checkSize() {
        if (window.innerWidth < 768) {
            if (Object.keys(this.swiper).length === 0) {
                this.tabContent.forEach((container: HTMLElement) => {
                    this.swiper[container.id] = new Swiper(container, {
                        lazy: false,
                        centeredSlides: false,
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    });
                })

                if (typeof this.swiper['tab-recommend'] !== 'undefined') {
                    this.swiper['tab-recommend'].on('slideChange', (swiper) => {
                        let length = swiper.slides.length;
                        let positionLoaded = length / 2;
                        if (swiper.activeIndex >= positionLoaded && !this.loaded) {
                            this.lazyLoad((msg) => {
                                swiper.appendSlide(msg)
                            })
                        }
                    })
                }
            } else {
                for (let k in this.swiper) {
                    if (this.swiper[k].destroyed) {
                        this.swiper[k].init()
                        this.swiper[k].destroyed = false;
                    }
                }
            }
        } else {
            for (let k in this.swiper) {
                this.swiper[k].destroy(false, true)
            }

            this.checkScroll();
        }
    }


}

export default EpisodeSlider;
